import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const purchases = [{
  name: 'Giulia R.',
  city: 'Milano'
}, {
  name: 'Marco V.',
  city: 'Roma'
}, {
  name: 'Francesca L.',
  city: 'Bologna'
}, {
  name: 'Andrea P.',
  city: 'Torino'
}, {
  name: 'Elena C.',
  city: 'Firenze'
}, {
  name: 'Matteo S.',
  city: 'Napoli'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [purchase, setPurchase] = useState(purchases[0]);
  useEffect(() => {
    const show = () => {
      setPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 6200);
    };
    const initial = window.setTimeout(show, 3500);
    const interval = window.setInterval(show, 18000);
    return () => {
      window.clearTimeout(initial);
      window.clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <aside aria-live="polite" className="pointer-events-none fixed bottom-3 left-3 right-3 z-50 flex justify-center sm:left-auto sm:right-4 sm:w-[290px] animate-slide-in" data-id="element-229" data-mp="1gtyeacqvcwwc"><div className="pointer-events-auto relative w-full rounded-lg border-2 border-brand-gold bg-brand-teal p-2.5 pr-8 text-white shadow-2xl" data-id="element-230" data-mp="27g17a0hnj2j5"><div className="absolute inset-x-0 top-0 h-1 rounded-t bg-brand-gold" data-id="element-231" data-mp="1xon85ttm44qj" /><button aria-label="Chiudi notifica" onClick={() => setVisible(false)} className="absolute right-2 top-2 text-white/70 hover:text-white" data-id="element-232" data-mp="1xmty04jsj2ds"><XIcon className="h-4 w-4" data-id="element-233" data-mp="2qe3y8ktrf9jl" /></button><div className="flex items-center gap-2.5" data-id="element-234" data-mp="2qd2c9lb7h2n3"><span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-gold text-brand-ink" data-id="element-235" data-mp="2lehju8273n97"><ShoppingBagIcon className="h-4 w-4" data-id="element-236" data-mp="2gf4ot01679vj" /></span><div className="leading-tight" data-id="element-237" data-mp="2gdtj2uo5zs1s"><p className="text-sm font-extrabold" data-id="element-238" data-mp="2gh938bwp3ra2">{purchase.name}</p><p className="text-[11px] font-semibold text-white/80" data-id="element-239" data-mp="2cd19u1faln5i">{purchase.city}, Italia</p><p className="mt-0.5 text-xs font-bold text-[#F4D889]" data-id="element-240" data-mp="150ho79adujrr">ha appena acquistato FISIO PRO™</p></div></div></div></aside>;
}